import { Variant } from "lib/enum"

/**
 * BusinessObjType is a dynamic variant that can represent any business object type.
 * This allows new database types to work without code changes.
 * 
 * The type is represented as a Variant with the objectId as the tag (e.g., "C1", "S1", "X1").
 */
export type BusinessObjType = Variant<Record<string, undefined>, string>

/**
 * Creates a BusinessObjType variant from any string.
 * This is fully dynamic - no hardcoded types needed.
 * New database types will work automatically.
 **/
export function CreateBusinessObjType(objectId: string): BusinessObjType {
	return new Variant<Record<string, undefined>, string>(
		objectId as any,
		undefined
	) as BusinessObjType;
}
